import { useTranslation } from "@coworker/locales";
import { ComponentNotificationBodyOptionCount } from "@fixa/notifications";
import TaskNotificationPriority from "../TaskNotificationPriority";
import TaskNotificationSafety from "../TaskNotificationSafety";
import TaskNotificationStatus from "../TaskNotificationStatus";
import styles from "../task-notification.module.css";

interface TaskNotificationBodyOptionCountProps extends ComponentNotificationBodyOptionCount {
  read: boolean;
}
const TaskNotificationBodyOptionCount = ({
  props: { priority, safety, status, optionCountInfo },
}: TaskNotificationBodyOptionCountProps) => {
  const { t } = useTranslation();
  const { label, count } = optionCountInfo;
  return (
    <div className={styles["task-notification-item-body"] ?? ""}>
      <div className={styles["task-notification-item-body-texts"] ?? ""}>
        {priority && <TaskNotificationPriority />}
        {safety && <TaskNotificationSafety />}
        {!!label && <div>{t(label, { count })}</div>}
      </div>
      {(status === "completed" || status === "closed") && (
        <TaskNotificationStatus status={status} />
      )}
    </div>
  );
};

export default TaskNotificationBodyOptionCount;
